import * as React from "react";
import { useState } from "react";
import CategoriesStyles from "./Categories.styles";

const {
    CategoriesMainContainer,
    CategoriesContainer,
    CategoriesBgBox,
    CategoriesBox,
    CategoryText,
} = CategoriesStyles;

const Categories = ({ categories, currentCategory, categorize }) => {
    const [categoriesOffset, setCategoriesOffset] = useState(1);
    const mobileCategoriesFirst = categories.slice(
        0,
        Math.ceil(categories.length / 2) + categoriesOffset
    );
    const mobileCategoriesSecond = categories.slice(
        Math.ceil(categories.length / 2) + categoriesOffset,
        categories.length
    );

    return (
        <CategoriesMainContainer>
            <CategoriesContainer>
                {categories.map((category, idx) => {
                    return (
                        <CategoriesBgBox
                            key={idx}
                            onClick={() => categorize(category)}
                        >
                            <CategoriesBox>
                                <CategoryText
                                    category={category}
                                    currentCategory={currentCategory}
                                >
                                    {category}
                                </CategoryText>
                            </CategoriesBox>
                        </CategoriesBgBox>
                    );
                })}
            </CategoriesContainer>
            <CategoriesContainer mobile>
                {mobileCategoriesFirst.map((category, idx) => {
                    return (
                        <CategoriesBgBox key={idx}>
                            <CategoriesBox>
                                <CategoryText>{category}</CategoryText>
                            </CategoriesBox>
                        </CategoriesBgBox>
                    );
                })}
            </CategoriesContainer>
            <CategoriesContainer mobile>
                {mobileCategoriesSecond.map((category, idx) => {
                    return (
                        <CategoriesBgBox key={idx}>
                            <CategoriesBox>
                                <CategoryText>{category}</CategoryText>
                            </CategoriesBox>
                        </CategoriesBgBox>
                    );
                })}
            </CategoriesContainer>
        </CategoriesMainContainer>
    );
};

export default Categories;
